"use client";

import { useRealmServices } from "@easybiz/component-shared";
import { useState } from "react";

function useCheckoutState(propBusinessCode, propService, propCustomer, propEditOrder) {
  const businesses = useRealmServices();
  const [stateBusinessCode, setBusinessCode] = useState();
  const defaultService = businesses && businesses[0];
  const [stateService, setService] = useState();
  const [stateCustomer, setCustomer] = useState();
  const [stateEditOrder, setEditOrder] = useState();
  const editOrder = propEditOrder || stateEditOrder;
  const businessCode = editOrder ? editOrder.get("business.id") : propBusinessCode || stateBusinessCode;
  const service = editOrder ? editOrder.get("service") : propService || stateService || defaultService;
  const customer = editOrder ? editOrder.get("customer") : propCustomer || stateCustomer;

  return {
    businessCode,
    service,
    customer,
    editOrder,
    setBusinessCode,
    setService,
    setCustomer,
    setEditOrder,
  };
}

export default useCheckoutState;
